<template>
  <!-- ============================================================ -->
  <!-- 价格页 — 独立站全功能免费开放                                 -->
  <!-- ============================================================ -->
  <div class="pricing">
    <!-- ==================== 1. Hero 横幅 ==================== -->
    <section class="pricing-hero">
      <div class="pricing-hero__inner">
        <div class="pricing-hero__content">
          <p class="pricing-hero__tag">
            {{ $t('推广期特别福利 · 限时免费开放全部功能') }}
          </p>
          <h1 class="pricing-hero__title">
            {{ $t('独立站全功能免费开放') }}
          </h1>
          <p class="pricing-hero__subtitle">
            {{ $t('0元建站 · 0交易佣金 · 无限商品 · 无限流量 · 无需信用卡') }}
          </p>
          <div class="pricing-hero__actions">
            <button
              class="pricing-hero__btn pricing-hero__btn--primary"
              @click="$router.push('/sign-up')"
            >
              {{ $t('立即免费建站') }}
            </button>
            <button
              class="pricing-hero__btn pricing-hero__btn--outline"
              @click="scrollToSection('pricing-compare')"
            >
              {{ $t('查看完整功能') }}
            </button>
          </div>
          <p class="pricing-hero__note">
            {{ $t('无需绑定信用卡 · 推广期注册永久享受免费权益 · 后期定制升级另行通知') }}
          </p>
          <!-- 价格展示 -->
          <div class="pricing-hero__price">
            <span class="pricing-hero__price-amount">{{ $t('¥0') }}</span>
            <span class="pricing-hero__price-unit">{{ $t('/ 永久') }}</span>
          </div>
        </div>
        <div class="pricing-hero__visual">
          <img :src="require('@/assets/images/pricing/Hero-right.png')" alt="" class="pricing-hero__visual-img">
        </div>
      </div>
    </section>

    <!-- 功能特性徽章 -->
    <div class="pricing-pills">
      <ul class="pricing-pills__list">
        <li
          v-for="pill in heroPills"
          :key="pill.label"
          class="pricing-pills__item"
        >
          <img
            :src="pill.icon"
            alt=""
            class="pricing-pills__icon"
            loading="lazy"
          >
          <span>{{ $t(pill.label) }}</span>
        </li>
      </ul>
    </div>

    <!-- ==================== 2. 功能对比表 ==================== -->
    <section
      ref="pricing-compare"
      class="pricing-compare"
    >
      <div class="pricing-compare__inner">
        <h2 class="pricing-compare__title">
          {{ $t('为什么选择 Taoify？ 免费完胜付费版') }}
        </h2>
        <p class="pricing-compare__subtitle">
          {{ $t('同等功能甚至更多，Taoify 永久免费，你还在为高昂月费困扰吗？') }}
        </p>
        <div class="pricing-compare__table">
          <!-- 表头 -->
          <div class="pricing-compare__header">
            <div class="pricing-compare__header-label">
              {{ $t('功能对比') }}
            </div>
            <div class="pricing-compare__header-col pricing-compare__header-col--taoify">
              <img :src="require('@/assets/images/home/CoreComparison-taoify@2x.png')" alt="Taoify" class="pricing-compare__header-logo">
            </div>
            <div class="pricing-compare__header-col">
              <img :src="require('@/assets/images/home/CoreComparison-shopify@2x.png')" alt="Shopify" class="pricing-compare__header-logo">
            </div>
            <div class="pricing-compare__header-col">
              <span>{{ $t('其他平台') }}</span>
            </div>
          </div>
          <!-- 表体 -->
          <div
            v-for="(row, ri) in compareRows"
            :key="ri"
            class="pricing-compare__row"
          >
            <div class="pricing-compare__row-label">
              {{ $t(row.label) }}
            </div>
            <div
              v-for="(col, ci) in row.cols"
              :key="ci"
              :class="['pricing-compare__row-cell', { 'pricing-compare__row-cell--taoify': ci === 0 }]"
            >
              <span
                v-if="col.icon"
                class="pricing-compare__row-icon"
              >{{ rowIcon(col) }}</span>
              <span>{{ $t(col.text) }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== 3. 功能特性网格  ==================== -->
    <section class="pricing-features">
      <div class="pricing-features__inner">
        <p class="pricing-features__label">
          {{ $t('无限可能 全部免费') }}
        </p>
        <h2 class="pricing-features__title">
          {{ $t('包含所有核心权益，无隐藏费用') }}
        </h2>
        <p class="pricing-features__desc">
          {{ $t('从建站到营销，全套跨境电商解决方案永久0元') }}
        </p>
        <div class="pricing-features__grid">
          <div
            v-for="group in featureGroups"
            :key="group.category"
            class="pricing-features__card"
          >
            <div class="pricing-features__card-overlay" />
            <div class="pricing-features__card-inner">
              <h3 class="pricing-features__card-title">
                {{ $t(group.category) }}
              </h3>
              <ul class="pricing-features__card-list">
                <li
                  v-for="item in group.items"
                  :key="item"
                  class="pricing-features__card-item"
                >
                  <span class="pricing-features__card-check">✅</span>
                  <span>{{ $t(item) }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ==================== 4. 常见问题 ==================== -->
    <section
      ref="faqSection"
      class="pricing-faq"
    >
      <h2 class="pricing-faq__title">
        {{ $t('常见问题') }}
      </h2>
      <dl class="pricing-faq__list">
        <div
          v-for="(faq, idx) in faqList"
          :key="idx"
          :class="['pricing-faq__item', { 'pricing-faq__item--open': faq.open }]"
        >
          <dt
            class="pricing-faq__q"
            @click="toggleFaq(idx)"
          >
            {{ $t(faq.q) }}
          </dt>
          <dd
            v-if="faq.a"
            v-show="faq.open"
            class="pricing-faq__a"
          >
            {{ $t(faq.a) }}
          </dd>
        </div>
      </dl>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'Pricing',
    data () {
      return {
        /* ---------- Hero 功能徽章 ---------- */
        heroPills: [
          { label: '免费建站', icon: require('@/assets/images/pricing/pills-1.png') },
          { label: '免费模板', icon: require('@/assets/images/pricing/pills-2.png') },
          { label: '0交易佣金', icon: require('@/assets/images/pricing/pills-3.png') },
          { label: '无限商品', icon: require('@/assets/images/pricing/pills-4.png') },
          { label: '无限流量', icon: require('@/assets/images/pricing/pills-5.png') },
          { label: '1688铺货', icon: require('@/assets/images/pricing/pills-6.png') },
          { label: '20+语言', icon: require('@/assets/images/pricing/pills-7.png') },
        ],

        /* ---------- 对比表行数据 ---------- */
        checkIcon: '✅',
        crossIcon: '❌',
        compareRows: [
          { label: '月费', cols: [{ text: '完全免费', icon: 'check' }, { text: '$29/月起', icon: 'cross' }, { text: '$15/月起', icon: 'cross' }] },
          { label: '交易佣金', cols: [{ text: '0佣金', icon: 'check' }, { text: '0.5%-2%', icon: 'cross' }, { text: '1%-3%', icon: 'cross' }] },
          { label: '建站/模板数量', cols: [{ text: '完全免费+100+模板', icon: 'check' }, { text: '部分免费，高级收费', icon: 'cross' }, { text: '受限模板', icon: 'cross' }] },
          { label: '多语言支持', cols: [{ text: '支持20+语言', icon: 'check' }, { text: '需付费插件', icon: 'cross' }, { text: '部分限制', icon: 'cross' }] },
          { label: '1688/速卖通铺货', cols: [{ text: '免费内置', icon: 'check' }, { text: '第三方付费插件', icon: 'cross' }, { text: '不支持/昂贵', icon: 'cross' }] },
          { label: '支付宝/微信收款', cols: [{ text: '原生支持', icon: 'check' }, { text: '配置复杂/插件', icon: 'cross' }, { text: '极少支持', icon: 'cross' }] },
          { label: '多仓库/物流跟踪', cols: [{ text: '完整功能', icon: 'check' }, { text: '需升级方案', icon: 'cross' }, { text: '缺失', icon: 'cross' }] },
          { label: '客服支持', cols: [{ text: '7*24小时极速响应', icon: 'check' }, { text: '英文/时差困扰', icon: 'cross' }, { text: '工作日服务', icon: 'cross' }] },
        ],

        /* ---------- 功能特性分组 ---------- */
        featureGroups: [
          {
            category: '建站 & 设计',
            items: ['免费响应式建站', '100+免费模板', '自定义域名绑定'],
          },
          {
            category: '商品管理',
            items: ['无限商品上传', '1688一键铺货', 'AI多语言翻译'],
          },
          {
            category: '收款结算',
            items: ['PayPal/信用卡/本地支付', '支付宝/微信支付', '0%交易佣金', '多货币自动结算'],
          },
          {
            category: '物流 & 履约',
            items: ['全球物流方案', '多仓库管理', '实时物流跟踪'],
          },
          {
            category: '订单 & 售后',
            items: ['自动化订单处理', '批量操作/打印', '售后/退款管理'],
          },
          {
            category: '营销增长',
            items: ['优惠券/折扣码', '会员等级体系', 'SEO & 社交媒体集成'],
          },
          {
            category: '优质服务',
            items: ['7x24小时中文客服', '详细教程/文档', '新卖家培训支持'],
          },
          {
            category: '更多特权',
            items: ['持续免费升级新功能', '专属客户经理通道', '优先体验企业版内测'],
          },
        ],

        /* ---------- 常见问题 ---------- */
        faqList: [
          {
            q: '真的是完全免费吗？有陷阱吗？',
            a: 'Taoify 基础版永久免费，无隐藏条款。无月费、无交易佣金、无商品数量限制、无流量限制。您无需绑定任何信用卡即可开始使用。我们通过企业版定制服务盈利，但基础功能不受任何影响。',
            open: false,
          },
          {
            q: '免费版有功能限制吗？例如商品数量、流量？',
            a: '免费版无商品数量和流量限制。您可以使用全部核心功能：完整建站工具、100+模板、多语言支持、1688铺货、多种支付方式集成、物流管理等。所有基本电商运营需求均免费开放。',
            open: false,
          },
          {
            q: '以后会强制收费吗？已注册用户受影响吗？',
            a: '不会。在推广期内注册的用户永久享有免费权益。未来即使推出付费企业版，已注册用户的免费权益保持不变，不会受任何影响。我们承诺不改变已有的免费政策。',
            open: false,
          },
          {
            q: '需要绑定信用卡才能开始吗？',
            a: '完全不需要！您无需提供任何支付信息或绑定信用卡，只需使用电子邮箱完成注册即可立即开始免费建站。我们坚持零门槛、零成本的入门体验。',
            open: false,
          },
          {
            q: '支持哪些收款和货币？',
            a: '支持 PayPal、信用卡（Visa/MasterCard/AmEx）、支付宝、微信支付等100+支付渠道。支持USD、EUR、GBP、CNY等主流货币自动换算，买家端按本地货币展示价格，提升下单转化率。',
            open: true,
          },
        ],
      }
    },
    methods: {
      rowIcon (col) {
        if (col.icon === 'check') return this.checkIcon
        if (col.icon === 'cross') return this.crossIcon
        return col.icon || ''
      },
      toggleFaq (idx) {
        const item = this.faqList[idx]
        const wasOpen = item.open
        this.faqList.forEach((f) => { f.open = false })
        item.open = !wasOpen
      },
      scrollToSection (ref) {
        const el = this.$refs[ref]
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      },
    },
  }
</script>

<style scoped lang="scss">
/* ================================================================
   CSS 变量 — 设计令牌 (1:1 对齐蓝湖标注)
   ================================================================ */
.pricing {
  --c-primary: #7331ff;
  --c-primary-dark: #675be6;
  --c-primary-gradient: linear-gradient(180deg, #aa98fc 0%, #7331ff 100%);
  --c-primary-gradient-45: linear-gradient(46deg, #7331ff 0%, #a855f7 100%);
  --c-text-heading: #333333;
  --c-text-body: #666666;
  --c-text-muted: #999999;
  --c-text-gray: #808080;
  --c-white: #ffffff;
  --c-bg-light: #f9fafb;
  --c-bg-gray: #f7f7f7;
  --c-bg-footer: #e6e6e6;
  --c-border: #ededed;
  --c-green: #16a34a;
  --max-w: 1200px;
  --r-xs: 4px;
  --r-sm: 6px;
  --r-md: 12px;
  --r-lg: 16px;
  --r-xl: 20px;
  --r-xxl: 34px;
  --r-tag: 47px;
  --r-pill: 9999px;
  --r-round: 50%;

  background-color: var(--c-white);
  font-family: 'Source Han Sans CN', 'PingFang SC', 'Microsoft YaHei', 'Roboto', 'Inter', sans-serif;
  color: var(--c-text-heading);
  overflow-x: hidden;
}

/* ================================================================
   1. Hero 横幅
   ================================================================ */
.pricing-hero {
  position: relative;

  background: url('~@/assets/images/pricing/Hero-bg.png') center no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner {
    max-width: var(--max-w);
    width: 100%;
    margin: 0 auto;
    padding: 80px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__content {
    flex: 0 0 600px;
    position: relative;
  }

  &__visual {
    flex: 0 0 480px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__visual-img {
    max-width: 100%;
    max-height: 480px;
    object-fit: contain;
  }

  &__tag {
    display: inline-block;
    background: rgba(255, 255, 255, 0.6);
    border-radius: var(--r-tag);
    padding: 4px 16px;
    font-size: 16px;
    color: #000;
    margin: 0;
    line-height: 24px;
  }

  &__title {
    margin: 16px 0 0;
    font-size: 52px;
    font-weight: 700;
    font-family: 'Source Han Sans CN', sans-serif;
    line-height: 1.2;
    color: var(--c-white);
  }

  &__subtitle {
    margin: 16px 0 0;
    font-size: 24px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.4;
  }

  &__actions {
    display: flex;
    gap: 20px;
    margin-top: 32px;
  }

  &__btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Source Han Sans CN', sans-serif;
    border-radius: var(--r-xxl);
    height: 51px;
    width: 180px;
    transition: opacity 0.15s;
    &:hover { opacity: 0.9; }
    &:active { opacity: 0.7; }

    &--primary {
      background: var(--c-primary-gradient);
      color: var(--c-white);
      box-shadow: 0 4px 4px 0 rgba(103, 91, 230, 0.2);
    }
    &--outline {
      background: var(--c-white);
      color: #0f2128;
      box-shadow: 0 4px 18px 0 rgba(103, 91, 230, 0.1);
    }
  }

  &__note {
    margin: 16px 0 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    line-height: 1.5;
  }

  /* 右侧占位 */
  &__placeholder {
    flex: 0 0 420px;
    height: 380px;
  }

  /* 价格展示 */
  &__price {
    margin-top: 24px;
  }

  &__price-amount {
    font-size: 72px;
    font-weight: 700;
    background: var(--c-primary-gradient-45);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  &__price-unit {
    font-size: 20px;
    color: var(--c-text-muted);
    margin-left: 4px;
  }
}

/* 功能特性徽章 — 独立区块 */
.pricing-pills {

  padding: 20px 0;

  &__list {
    max-width: var(--max-w);
    margin: 0 auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 12px;
    list-style: none;
    padding: 0 20px;
  }

  &__item {
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(179, 173, 243, 0.1);
    border-radius: 12px;
    padding: 30px 34px;
    font-size: 16px;
    color: var(--c-text-heading);
    line-height: 24px;
  }

  &__icon {
    width: 20px;
    height: 20px;
  }
}

/* ================================================================
   2. 功能对比表
   ================================================================ */
.pricing-compare {
  background: var(--c-bg-gray);
  padding: 80px 0;

  &__inner {
    max-width: var(--max-w);
    margin: 0 auto;
  }

  &__title {
    font-size: 32px;
    font-weight: 700;
    color: var(--c-text-heading);
    text-align: center;
    margin: 0;
    line-height: 36px;
  }

  &__subtitle {
    font-size: 18px;
    color: var(--c-text-muted);
    text-align: center;
    margin: 12px 0 40px;
    line-height: 24px;
  }

  &__table {
    background: var(--c-white);
    overflow: hidden;
  }

  &__header {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    border-bottom: 1px solid var(--c-border);
  }

  &__header-label {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 500;
    color: var(--c-text-heading);
    padding: 20px 16px;
    background: var(--c-bg-footer);
  }

  &__header-col {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 16px;
    font-size: 20px;
    font-weight: 500;
    background: var(--c-bg-footer);

    &--taoify { background: rgba(115,49,255,0.2); }
  }

  &__header-logo {
    height: 32px;
    object-fit: contain;
  }

  &__header-icon {
    width: 28px;
    height: 28px;
  }

  &__row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    border-bottom: 1px solid var(--c-border);

    &:last-child { border-bottom: none; }
  }

  &__row-label {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 18px 16px;
    font-size: 16px;
    color: #000;
    background: var(--c-bg-gray);
    font-weight: 500;
    text-align: center;
  }

  &__row-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 18px 16px;
    font-size: 14px;
    color: #000;
    line-height: 20px;
    text-align: center;

    &--taoify {
      background: rgba(115, 49, 255, 0.05);
    }
  }

  &__row-icon {
    font-size: 18px;
    line-height: 1;
    flex-shrink: 0;
  }
}

/* ================================================================
   3. 功能特性网格
   ================================================================ */
.pricing-features {
  background: url('~@/assets/images/pricing/features-bg.png') center no-repeat;
  background-size: cover;
  padding: 80px 0;

  &__inner {
    max-width: var(--max-w);
    margin: 0 auto;
    text-align: center;
  }

  &__label {
    font-size: 20px;
    color: var(--c-white);
    margin: 0;
    line-height: 28px;
  }

  &__title {
    font-size: 32px;
    font-weight: 700;
    color: var(--c-white);
    margin: 8px 0 0;
    line-height: 36px;
  }

  &__desc {
    font-size: 20px;
    color: var(--c-white);
    margin: 12px 0 40px;
    line-height: 28px;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr 1fr;
    gap: 24px;
  }

  &__card {
    position: relative;
    border-radius: var(--r-xl);
    text-align: left;
    overflow: visible;
    height: 100%;
  }

  /* 底层遮罩 — 始终方正不动，hover 淡入 */
  &__card-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    opacity: 0;
    z-index: 1;
    border-radius: var(--r-xl);
    transition: opacity 0.35s ease;
  }

  /* 上层内容 — hover 以左下角为轴向左旋转 */
  &__card-inner {
    position: relative;
    z-index: 2;
    height: 100%;
    background: rgba(255, 255, 255, 0.12);
    border-radius: var(--r-xl);
    padding: 32px 24px;
    transform: rotate(0deg);
    transform-origin: left bottom;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
    transition: transform 0.4s ease, background 0.4s ease, box-shadow 0.4s ease;
  }

  &__card:hover &__card-overlay {
    opacity: 1;
  }

  &__card:hover &__card-inner {
    transform: rotate(-6deg);
    background: #fff;
    box-shadow: 0 8px 30px 0 rgba(0, 0, 0, 0.25);
  }

  &__card-title {
    font-size: 20px;
    font-weight: 500;
    color: var(--c-white);
    margin: 0 0 20px;
    line-height: 28px;
    transition: color 0.35s ease;
  }

  &__card:hover &__card-title {
    color: var(--c-text-heading);
  }

  &__card-list {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__card-item {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    color: var(--c-white);
    line-height: 20px;
    transition: color 0.35s ease;
  }

  &__card:hover &__card-item {
    color: var(--c-text-body);
  }

  &__card-check {
    font-size: 16px;
    line-height: 1;
    flex-shrink: 0;
  }
}

/* ================================================================
   4. 常见问题
   ================================================================ */
.pricing-faq {
  max-width: var(--max-w);
  margin: 0 auto;
  padding: 60px 20px;

  &__title {
    font-size: 30px;
    font-weight: 700;
    color: var(--c-text-heading);
    text-align: center;
    margin: 0 0 32px;
  }

  &__list {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0;
  }

  &__item {
    border-bottom: 1px solid #eee;
    padding: 16px 0;

    &--open {
      .pricing-faq__q::after { content: '−'; }
    }
  }

  &__q {
    font-size: 18px;
    font-weight: 500;
    color: var(--c-text-heading);
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &::after {
      content: '+';
      font-size: 22px;
      color: var(--c-text-muted);
      flex-shrink: 0;
    }
  }

  &__a {
    font-size: 14px;
    color: var(--c-text-body);
    margin: 8px 0 0;
    line-height: 1.6;
  }
}

/* ================================================================
   响应式
   ================================================================ */
@media (max-width: 1280px) {
  .pricing-hero__inner,
  .pricing-compare__inner,
  .pricing-features__inner,
  .pricing-pills__list {
    padding-left: 20px;
    padding-right: 20px;
  }
}

@media (max-width: 1024px) {
  .pricing-hero {
    min-height: auto;

    &__inner { flex-direction: column; padding: 60px 20px 20px; }
    &__content { flex: auto; width: 100%; text-align: center; }
    &__title { font-size: 36px; }
    &__subtitle { font-size: 18px; }
    &__actions { justify-content: center; }
    &__note { font-size: 13px; }
    &__visual { flex: auto; width: 100%; max-width: 400px; height: auto; margin-top: 40px; }
    &__visual-img { max-height: 300px; }
  }

  .pricing-pills {
    padding: 16px 0;

    &__item { padding: 16px 22px; font-size: 14px; }
  }

  .pricing-compare {
    padding: 60px 0;

    &__table, &__header, &__row {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    &__title { font-size: 24px; }
    &__subtitle { font-size: 16px; }
    &__header-label { font-size: 16px; padding: 14px 10px; }
    &__header-col { padding: 14px 10px; font-size: 16px; }
    &__row-label { font-size: 13px; padding: 12px 10px; }
    &__row-cell { font-size: 12px; padding: 12px 10px; gap: 4px; }
    &__row-icon { font-size: 16px; }
  }

  .pricing-features {
    &__grid { grid-template-columns: repeat(2, 1fr); grid-template-rows: auto; }
    &__title { font-size: 24px; }
    &__desc { font-size: 18px; }
    &__card-inner { padding: 24px 18px; }
  }
}

@media (max-width: 768px) {
  .pricing-hero {
    min-height: auto;

    &__inner { flex-direction: column; padding: 40px 16px 16px; }
    &__content { flex: auto; width: 100%; text-align: center; }
    &__tag { font-size: 14px; padding: 4px 12px; }
    &__title { font-size: 28px; }
    &__subtitle { font-size: 16px; }
    &__note { font-size: 12px; }
    &__btn { width: 140px; font-size: 15px; height: 44px; }
    &__actions { flex-direction: column; align-items: center; gap: 12px; }
    &__price-amount { font-size: 48px; }
    &__price-unit { font-size: 16px; }
    &__visual { max-width: 300px; }
  }

  .pricing-pills {
    padding: 12px 0;

    &__item { padding: 8px 14px; font-size: 13px; }
    &__icon { width: 16px; height: 16px; }
  }

  .pricing-compare {
    padding: 40px 0;

    &__title { font-size: 22px; }
    &__subtitle { font-size: 14px; margin-bottom: 24px; }
    &__table {
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
    &__header, &__row {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      min-width: 520px;
    }
    &__header-label { font-size: 14px; padding: 10px 6px; }
    &__header-col { padding: 10px 6px; font-size: 14px; }
    &__row-label { font-size: 11px; padding: 8px 6px; }
    &__row-cell { font-size: 11px; padding: 8px 6px; gap: 3px; }
    &__row-icon { font-size: 14px; }
  }

  .pricing-features {
    padding: 40px 0;

    &__label { font-size: 16px; }
    &__title { font-size: 22px; }
    &__desc { font-size: 14px; }
    &__grid { grid-template-columns: 1fr; grid-template-rows: auto; }
    &__card-inner { padding: 20px 16px; }
    &__card-title { font-size: 18px; }
    &__card-item { font-size: 13px; }
  }

  .pricing-faq {
    padding: 40px 16px;

    &__q { font-size: 16px; }
    &__title { font-size: 24px; }
  }
}
</style>
